import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="30px" column justifyStart>
          <CFView h3 futura bold color="#FFFFFF" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/sapporokitchensurrey/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Sapporo Japanese Kitchen Facebook"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/sapporokitchensurrey/?next=%2F&hl=en ">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Sapporo Japanese Kitchen Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#FFFFFF" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/sapporokitchensurrey/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sapporo Japanese Kitchen Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/sapporokitchensurrey/?next=%2F&hl=en ">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Sapporo Japanese Kitchen Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
